import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ContactUsService } from '../services/contactus.service';
import { ContactRequest } from '../models/contact-request';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  contactRequest: ContactRequest = new ContactRequest();
  msg: string = '';
  disableSend: boolean = false;
  loading = false;
  aurl: string = '';

  // SubjectTopics sourced via getSubjectTopics call from API
  subjectTopics: string[];

  constructor(
    private _router: Router,
    private _contactUsService: ContactUsService) {
    // Init container for request
    this.contactRequest = new ContactRequest();
  }

  getSubjectTopics() {
    this._contactUsService.getSubjectTopics()
      .subscribe(
      states => this.getSubjectTopicsSuccess(states),
      error => this.getSubjectTopicsFailed(error),
      () => console.log('Completed!'));
  }

  getSubjectTopicsSuccess(subjectTopics: any) {
    this.subjectTopics = subjectTopics;
  }

  getSubjectTopicsFailed(error: any) {
    this.msg = error;
  }

  sendContactRequest(contactUsRequest: NgForm): void {
    if (contactUsRequest.dirty && contactUsRequest.valid) {
      // form is valid and dirty - send request'
      this.loading = true;
      this._contactUsService.sendContactRequest(this.contactRequest)
        .subscribe(
        res => this.sendContactRequestSuccessful(res),
        error => this.sendContactRequestFailed(error),
        () => {
          setTimeout(() => {
            // show message for 2 seconds, then redirect back to main?
            this.msg = 'Returning to the Home page';
            // Navigate back to the home
            setTimeout(() => { this._router.navigate(['home']); }, 1750);
          }, 4000);
          console.log('ContactRequest Sent!');
        });
    }
  }

  sendContactRequestSuccessful(res: any) {
    console.log(res.message);
    this.loading = false;
    this.msg = res.message;
  }

  sendContactRequestFailed(error: any) {
    console.log(error.message);
    this.loading = false;
    this.msg = error.message;
  }

    ngOnInit() {
      // Load subject list from API
      this.getSubjectTopics();
  }

}



// WEBPACK FOOTER //
// ./src/app/contact-us/contact-us.component.ts